import { getCountries, parsePhoneNumber } from "react-phone-number-input";

// Define the excluded countries
const excludedCountries = [
  "IL",
  "KP",
  "RU",
  "UA",
  "CU",
  "PK",
  "SD",
  // "IN",
  "SY",
  "IR",
  "YE",
  "BD",
  "AF",
];

// Get all valid country codes from the phone number library and filter out excluded ones
export const filteredCountries = getCountries().filter(
  (code) => !excludedCountries.includes(code)
);

// Validation function to check if a phone number's country is excluded
export const validatePhoneNumberCountry = (phoneNumber) => {
  if (!phoneNumber) return { isValid: true, error: null };

  try {
    const parsedPhone = parsePhoneNumber(phoneNumber);
    if (!parsedPhone) {
      return { isValid: false, error: "Invalid phone number format" };
    }

    const countryCode = parsedPhone.country;
    if (excludedCountries.includes(countryCode)) {
      return {
        isValid: false,
        error: `Phone numbers from ${getCountryName(countryCode)} are not allowed`
      };
    }

    return { isValid: true, error: null };
  } catch (error) {
    return { isValid: false, error: "Invalid phone number format" };
  }
};

// Helper function to get country name from country code
const getCountryName = (countryCode) => {
  const countryNames = {
    "IL": "Israel",
    "KP": "North Korea",
    "RU": "Russia",
    "UA": "Ukraine",
    "CU": "Cuba",
    "PK": "Pakistan",
    "SD": "Sudan",
    // "IN": "India",
    "SY": "Syria",
    "IR": "Iran",
    "YE": "Yemen",
    "BD": "Bangladesh",
    "AF": "Afghanistan"
  };
  return countryNames[countryCode] || countryCode;
};

// Export excluded countries list for reference
export { excludedCountries };
